import React, { useState, useEffect } from "react";
import './YourPersonalInfoPage.scss'
// import { isMobile } from "../../helpers/helpers";
import CONSTANTS from "../../Constants";
import SummaryBlock from "../../components/SummaryBlock/SummaryBlock";
import Headline from "../../components/Title/Headlines";
import PersonalInfoForm from "../../components/PersonalInfo_form/PersonalInfoForm";
import StickyButton from "../../components/Forms/StickyButton";
import { CheckBox, TextArea, Attachments, Radio } from "../../components/Forms/Forms";
import fetchApiData from "../../apiHandlers/fetchApiData";
import { removeNumbers, getNewPhoneFormatValue, isMobile } from "../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import { setPersonalInformations, setListPremiumServices, setSelectedPremiumServicesToStore } from "../../redux-files/actions/action";
import { useDispatch, useSelector } from "react-redux";
import useBodyClass from "../../custom-Hooks/useBodyClass";
import { pushToGTMTracker, pushEventToGTM } from "../../helpers/trackerManager";
import arrowExpand from "../../images/AP/common_right_arrow.svg"


const YourPersonalInfoPage = () => {
    
    const initConsentMarketingProfiling = () => {
        if (
          PersonalInformationFromStore.ConsentMarketingProfiling !== undefined
        ) {
          return PersonalInformationFromStore.ConsentMarketingProfiling;
        } else if (
          PersonalInformationFromStore.ConsentMarketing !== undefined &&
          PersonalInformationFromStore.ConsentProfiling !== undefined
        ) {
          return (
            PersonalInformationFromStore.ConsentMarketing ||
            PersonalInformationFromStore.ConsentProfiling
          );
        } else return "";
    }

    const PersonalInformationFromStore = useSelector(state => state.ndel_store.personalInfos)
    const listPremiumServicesFromStore = useSelector(state => state.ndel_store.listPremiumServices)
    const storeSelectedPremiumServicesIdGroupe = useSelector(state => state.ndel_store.selectedPremiumServices)
    const dealerInfos = useSelector(state => state.ndel_store.dealer)
    const [premiumServicesList, setPremiumServicesList] = useState(listPremiumServicesFromStore || [])
    const [selectedPremiumServices, setSelectedPremiumServicesList] = useState(storeSelectedPremiumServicesIdGroupe || [])
    const [comment, setComment] = useState(PersonalInformationFromStore.comment || '')
    const [mobilityService, setMobilityService] = useState(PersonalInformationFromStore.mobilityService || false)
    const [commercialsState, setCommercialsState] = useState({
        acceptCommercialChoice: PersonalInformationFromStore.acceptCommercialChoice || false,
        commercialChoiceEmail: PersonalInformationFromStore.commercialChoiceEmail || false,
        commercialChoiceTel: PersonalInformationFromStore.commercialChoiceTel || false,
        commercialChoiceSms: PersonalInformationFromStore.commercialChoiceSms || false,
        commercialChoiceAdress: PersonalInformationFromStore.commercialChoiceAdress || false,
        commercialChoiceOther: PersonalInformationFromStore.commercialChoiceOther || false
    })
    const [formState, setFormState] = useState({
        civility: PersonalInformationFromStore.civility || "",
        firstName: PersonalInformationFromStore.firstName || "",
        lastName: PersonalInformationFromStore.lastName || "",
        email: PersonalInformationFromStore.email || "",
        phone: PersonalInformationFromStore.phone || "",
        contactTypes: PersonalInformationFromStore.contactTypes || "Email"
    })
    const [errorState, setErrorState] = useState({
        showFormError: false,
        showFirstNameFormatError: false,
        showFirstNameSpecialChar: false,
        showFirstNameMaxLength: false,
        showLastNameFormatError: false,
        showLastNameSpecialChar: false,
        showLastNameMaxLength: false,
        showEmailFormatError: false,
        showPhoneFormatError: false,
        showCommentSpecialChar : false,
    })
    const [isLegalMentionsChecked, setIsLegalMentionsChecked] = useState(PersonalInformationFromStore.acceptLegalNotices || false)
    const [isNewConsentExpanded, setIsNewConsentExpanded] = useState(false);
    const [marketingProfilingInput, setMarketingProfilingInput] = useState(initConsentMarketingProfiling());
    const [marketingInput, setMarketingInput] = useState(
      PersonalInformationFromStore.ConsentMarketing !== undefined
        ? PersonalInformationFromStore.ConsentMarketing
        : ""
    );
    const [profilingInput, setProfilingInput] = useState(
      PersonalInformationFromStore.ConsentProfiling !== undefined
        ? PersonalInformationFromStore.ConsentProfiling
        : ""
    );
    const [thirdPartyInput, setThirdPartyInput] = useState(
      PersonalInformationFromStore.ConsentThirdParty !== undefined
        ? PersonalInformationFromStore.ConsentThirdParty
        : ""
    );

    const navigate = useNavigate();
    const dispatch = useDispatch()
    useEffect(() => {
        premiumServicesList !== 'undefind' && premiumServicesList.length < 1 && getPremiumServices()
        pushToGTMTracker('personal-informations-page', window.siteConfig.quotingInfospersos.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealerInfos)
        window.scrollTo(0, 0)
    }, [])

    const getPremiumServices = () => {
        const PREMIUM_SERVICES_API = new fetchApiData()
        PREMIUM_SERVICES_API.getPremiumServices()
            .then(
                res => {
                    setPremiumServicesList(res.d)
                    dispatch(setListPremiumServices(res.d))
                })
            .catch(error => {
                console.error(error)
            })
    }

    const handleFormInputsChange = (event) => {
        let value = event.target.value;
        if (event.target.name === 'firstName') {
            if (event.target.value.trim().match(/[0-9]/g)) {
                setErrorState({
                    ...errorState,
                    showFirstNameFormatError: true,
                    showFirstNameSpecialChar: false,
                    showFirstNameMaxLength: false,
                });
            }
            else if (event.target.value.trim().match(/[^\p{L}\p{M}\s']/gu)) {
                setErrorState({
                    ...errorState,
                    showFirstNameFormatError: false,
                    showFirstNameSpecialChar: true,
                    showFirstNameMaxLength: false,
                });
            } else if (event.target.value.length > 50)
                setErrorState({
                    ...errorState,
                    showFirstNameFormatError: false,
                    showFirstNameSpecialChar: false,
                    showFirstNameMaxLength: true,
                });
            else {
                setErrorState({
                    ...errorState,
                    showFirstNameFormatError: false,
                    showFirstNameSpecialChar: false,
                    showFirstNameMaxLength: false,
                });
                setFormState({
                    ...formState,
                    [event.target.name]: value,
                });
            }
        } else if (event.target.name === 'lastName') {
            if (event.target.value.trim().match(/[0-9]/g)) {
                setErrorState({
                    ...errorState,
                    showLastNameFormatError: true,
                    showLastNameSpecialChar: false,
                    showLastNameMaxLength: false,
                });
            } else if (event.target.value.trim().match(/[^\p{L}\p{M}\s']/gu)) {
                setErrorState({
                    ...errorState,
                    showLastNameFormatError: false,
                    showLastNameSpecialChar: true,
                    showLastNameMaxLength: false,
                });
            } else if (event.target.value.length > 50)
                setErrorState({
                    ...errorState,
                    showLastNameFormatError: false,
                    showLastNameSpecialChar: false,
                    showLastNameMaxLength: true,
                });
            else {
                setErrorState({
                    ...errorState,
                    showLastNameFormatError: false,
                    showLastNameSpecialChar: false,
                    showLastNameMaxLength: false,
                });
                setFormState({
                    ...formState,
                    [event.target.name]: value,
                });
            }
            }
        
        if (event.target.name === 'email') {
            const mailRegExp = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}')
            if (value.length <= 0 || mailRegExp.test(value)) {
                setErrorState({
                    ...errorState,
                    showEmailFormatError: false
                })
            }
        }
        if (event.target.name === 'phone') {
            let phoneregex = isPhoneNumberOptional ? `^$|${CONSTANTS.SITE_INFO.PHONEREGEX.replace(/\//g, '')}` : CONSTANTS.SITE_INFO.PHONEREGEX.replace(/\//g, '')
            let newRegex = new RegExp(phoneregex);
            value = getNewPhoneFormatValue(value)
            value.length <= 0 && setCommercialsState({
                ...commercialsState,
                commercialChoiceTel: false,
                commercialChoiceSms: false
            })
            setErrorState({
                ...errorState,
                showPhoneFormatError: !newRegex.test(value)
            })
        }
        
        if (
          event.target.name !== 'firstName' &&
          event.target.name !== 'lastName'
        )
          setFormState({
            ...formState,
            [event.target.name]: value,
          });
    }

    const checkEmailFormat = (event) => {
        const value = event.target.value;
        const mailRegEx = new RegExp('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}')
        if (value.length > 0 && !mailRegEx.test(value)) {
            setErrorState({
                ...errorState,
                showEmailFormatError: true
            })
        }
    }

    const checkFormValidity = () => {
        let phoneregex = isPhoneNumberOptional ? `^$|${CONSTANTS.SITE_INFO.PHONEREGEX.replace(/\//g, '')}` : CONSTANTS.SITE_INFO.PHONEREGEX.replace(/\//g, '')
        let newRegex = new RegExp(phoneregex);
        if (!formState.firstName || !formState.lastName || !formState.email || !formState.civility || !newRegex.test(getNewPhoneFormatValue(formState.phone))) {
            setErrorState({
                ...errorState,
                showFormError: true,
                showPhoneFormatError: !newRegex.test(getNewPhoneFormatValue(formState.phone))
            })
        } else {
            dispatch(setSelectedPremiumServicesToStore(selectedPremiumServices))
            dispatch(setPersonalInformations({
                ...formState,
                comment: comment,
                ...commercialsState,
                commercialChoiceOther: commercialsState.commercialChoiceOther ? CONSTANTS.LABELS.userinfos_consent_checkbox_other : "",
                acceptLegalNotices: isLegalMentionsChecked,
                ConsentMarketing : isNewConsentActive ? marketingInput : false,
				ConsentProfiling : isNewConsentActive ? profilingInput : false,
				ConsentThirdParty : isNewConsentActive ? thirdPartyInput : false,
				ConsentMarketingProfiling : marketingProfilingInput,
                mobilityService : mobilityService
            }))
            setErrorState({
                ...errorState,
                showFormError: false,
            })
            pushEventToGTM({
                pageName: 'personnal info',
                eventAction: 'Redirection::Internal::Next_step',
                eventLabel: CONSTANTS.LABELS.common_v2_continue,
                eventCategory: 'Content'
            })
            navigate(CONSTANTS.SITE_ROUTS.SUMMARYPAGE)
        }
    }

    const acceptCommercialChoiceCheckboxIsActivated = !!Number(window.siteConfig.TypeContactCheck);
    const isEmailActivated = !!Number(window.siteConfig.ActivateEmail);
    const isTelephoneActivated = !!Number(window.siteConfig.ActivateTelephone);
    const isSMSActivated = !!Number(window.siteConfig.ActivateSMS);
    const isPostmailActivated = !!Number(window.siteConfig.ActivatePostmail);
    const isOtherActivated = !!Number(window.siteConfig.ActivateOther);
    const isPhoneNumberOptional = !!Number(window.siteConfig.MakePhoneNumberOptional);
    const isMentionLegalActivated = !!Number(window.siteConfig.DisplayGDPR);
    const ActivateAttachmentTool = (!!parseInt(CONSTANTS.SITE_INFO.ACTIVATEATTACHMENTTOOL))
    const isNewConsentActive = !!Number(
      window.siteConfig.ActiverNouveauxConsentements
    );

    let checkBoxDisabledClass = '';
    if (isPhoneNumberOptional && formState.phone.length <= 0) {
        checkBoxDisabledClass = 'checkbox-disabled';
        const smsTelCheckBox = document.querySelectorAll("#tel,#sms");
        for (let i = 0; i < smsTelCheckBox.length; i++) {
            smsTelCheckBox[i].checked = false;
        }
    }
    useBodyClass('personalInfo-page')
    return (

        <>
            {!isMobile() && <SummaryBlock showAppointmentBlock={true} />}
            {!isMobile() && <Headline
                Title={CONSTANTS.LABELS.userinfos_title}
                SubTitle={CONSTANTS.LABELS.userinfos_subtitle}
            />
            }
            <div className='personal_info-wrapper'>
                <div className='form_premiumServices-row'>
                    <div className='form_premiumServices-content'>
                        <div className='form-container'>
                            <PersonalInfoForm
                                formStateProps={formState}
                                errorStateProps={errorState}
                                onFormInputsChange={(event) => handleFormInputsChange(event)}
                                onEmailBlur={(event) => checkEmailFormat(event)}
                            />
                        </div>
                        {!isMobile() && <div className='bg_img-container'></div> /* show Only on Desktop*/}
                        <div className='premium_services'>
                            <h6 tabIndex='0' className='block-title'>{CONSTANTS.LABELS.userinfos_options_title}</h6>
                            <p tabIndex='0' className='block-subtitile'>{CONSTANTS.LABELS.userinfos_options_subtitle}</p>
                            {/*Premium service loop */}
                            {premiumServicesList.map(premiumService => {

                                return (
                                    premiumService.displayPI && dealerInfos.listPremiumServices.includes(premiumService.idServicePremium) && <div key={premiumService.idServicePremium} className='premium_services-block'>
                                        <div tabIndex='0' className='block-head'>
                                            <div dangerouslySetInnerHTML={{ __html: (premiumService.titre) }}></div>
                                        </div>
                                        <p tabIndex='0' className='description' dangerouslySetInnerHTML={{ __html: (premiumService.label) }}></p>
                                        <CheckBox
                                            name={premiumService.codeTech}
                                            id={premiumService.idServicePremium}
                                            label={CONSTANTS.LABELS.userinfos_options_checkbox}
                                            isChecked={selectedPremiumServices.map(({ idServicePremium }) => idServicePremium).includes(premiumService.idServicePremium)}
                                            onClick={(event) => {
                                                if (event.target.checked) {
                                                    setSelectedPremiumServicesList([...selectedPremiumServices, { idServicePremium: premiumService.idServicePremium, groupe: premiumService.groupe, codeIntern:premiumService.codeIntern }])
                                                    if(premiumService.codeIntern === "OM"){
                                                        setMobilityService(true)
                                                    }
                                                }
                                                else {
                                                    setSelectedPremiumServicesList(selectedPremiumServices.filter(item => item.idServicePremium !== premiumService.idServicePremium))
                                                }
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                </div>
                <div className='comment-attachment-row'>
                    <div className={`${!ActivateAttachmentTool ? 'full-width' : 'half-width'}`}>
                        <h4 className="section_title">
                            <label tabIndex='0' for='textarea-comment'>{CONSTANTS.LABELS.needs_comment_label1}</label>
                            <span tabIndex='0' className="section_title-help"> {`(${comment.length}/500 ${CONSTANTS.LABELS.summary_comment_label1})`} </span>
                        </h4>
                        <TextArea placeholder={CONSTANTS.LABELS.needs_comment_label2}
                            classes="services-comment"
                            id="textarea-comment"
                            maxLength={500}
                            value={comment}
                            onChange={(e) => {
                                if (
                                  e.target.value.match(
                                    /[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
                                  )
                                ) {
                                  setErrorState({
                                    ...errorState,
                                    showCommentSpecialChar: true,
                                  });
                                } else {
                                  setComment(e.target.value);
                                  setErrorState({
                                    ...errorState,
                                    showCommentSpecialChar: false,
                                  });
                                }
                                }}
                            iserror={errorState.showCommentSpecialChar}
							labelerror={CONSTANTS.LABELS.userinfos_error_name_special_char}
                        />

                    </div>
                    {ActivateAttachmentTool &&
                        <div className="half-width">
                            <h4 tabIndex='0' className="section_title">{CONSTANTS.LABELS.needs_attachment_title}
                                {/* {CONSTANTS.LABELS.needs_attachments_label1} */}
                                <span className="section_title-help">
                                <div dangerouslySetInnerHTML={{__html: CONSTANTS.LABELS.needs_attachment_subtitle}} />
                                </span>
                            </h4>
                            <Attachments classes="services-attachments" />
                        </div>
                    }
                </div>
                <div className='legal_infos-row'>
                    {!isNewConsentActive &&
                        <React.Fragment>
                            <p tabIndex='0' className='first-block' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.userinfos_consent_block1) }}></p>
                            {acceptCommercialChoiceCheckboxIsActivated
                                ?
                                <CheckBox wrapperClasses="accept-commercial-choice"
                                    id="accept-commercials"
                                    onClick={(e) => {
                                        const checkBoxes = document.getElementsByClassName("commercial-choice");
                                        for (var i = 0; i < checkBoxes.length; i++) {
                                            checkBoxes[i].firstChild.checked = false;
                                        }
                                        setCommercialsState({
                                            ...commercialsState,
                                            acceptCommercialChoice: e.target.checked,
                                            commercialChoiceEmail: false,
                                            commercialChoiceTel: false,
                                            commercialChoiceSms: false,
                                            commercialChoiceAdress: false,
                                            commercialChoiceOther: false
                                        })
                                    }

                                    }
                                    label={CONSTANTS.LABELS.userinfos_consent_block2}
                                    isChecked={commercialsState.acceptCommercialChoice} />
                                :
                                <p tabIndex='0' className='second-block' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.userinfos_consent_block2) }}></p>
                            }
                            
                            <div aria-disabled={!commercialsState.acceptCommercialChoice && acceptCommercialChoiceCheckboxIsActivated}
                                className={`commercial_Choices-block ${(!commercialsState.acceptCommercialChoice && acceptCommercialChoiceCheckboxIsActivated) ? 'disabled' : ''}`}>

                                {isEmailActivated && <CheckBox wrapperClasses="commercial-choice"
                                    id="email"
                                    onClick={(e) => setCommercialsState({ ...commercialsState, commercialChoiceEmail: e.target.checked })}
                                    label={CONSTANTS.LABELS.userinfos_consent_checkbox_email}
                                    isChecked={commercialsState.commercialChoiceEmail} />}
                                {isTelephoneActivated && <CheckBox wrapperClasses={`commercial-choice ${checkBoxDisabledClass}`}
                                    id="tel"
                                    onClick={(e) => setCommercialsState({ ...commercialsState, commercialChoiceTel: e.target.checked })}
                                    label={CONSTANTS.LABELS.userinfos_consent_checkbox_tel}
                                    isChecked={commercialsState.commercialChoiceTel} />}
                                {isSMSActivated && <CheckBox wrapperClasses={`commercial-choice ${checkBoxDisabledClass}`}
                                    id="sms"
                                    onClick={(e) => setCommercialsState({ ...commercialsState, commercialChoiceSms: e.target.checked })}
                                    label={CONSTANTS.LABELS.userinfos_consent_checkbox_sms}
                                    isChecked={commercialsState.commercialChoiceSms} />}
                                {isPostmailActivated && <CheckBox wrapperClasses="commercial-choice"
                                    id="adress"
                                    onClick={(e) => setCommercialsState({ ...commercialsState, commercialChoiceAdress: e.target.checked })}
                                    label={CONSTANTS.LABELS.userinfos_consent_checkbox_adress}
                                    isChecked={commercialsState.commercialChoiceAdress} />}
                                {isOtherActivated && <CheckBox wrapperClasses="commercial-choice"
                                    id="other"
                                    onClick={(e) => setCommercialsState({ ...commercialsState, commercialChoiceOther: e.target.checked })}
                                    label={CONSTANTS.LABELS.userinfos_consent_checkbox_other}
                                    isChecked={commercialsState.commercialChoiceOther} />}
                            </div>

                            <p tabIndex='0' className='third-block' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.userinfos_consent_block3) }}></p>
                        </React.Fragment>}
                    
                    {/*Insert new consent here*/}
                    {isNewConsentActive &&
                        <React.Fragment>
                            <div className="newConsentTitle newConsentMargin">{CONSTANTS.LABELS.userinfos_newconsent_title1}</div>
                            <div dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label1 }} className="newConsentMargin newConsentLineHeight"></div>

                            <div className="newConsentTitleRadioContainer">
                                <div className="newConsentTitle">{CONSTANTS.LABELS.userinfos_newconsent_title2}</div>
                                <Radio
                                    name="marketingProfiling"
                                    id="marketingProfiling-yes"
                                    label={CONSTANTS.LABELS.common_yes}
                                    isChecked={(marketingProfilingInput === true)}
                                    onChange={(e) => {
                                        setMarketingProfilingInput(true); 
                                        setMarketingInput(true); 
                                        setProfilingInput(true);
                                    }
                                    }
                                    customLabelStyle={{ paddingLeft : 5 }}
                                    customInputStyle={{ position: "relative" }}
                                />
                                <Radio
                                    name="marketingProfiling"
                                    id="marketingProfiling-no"
                                    label={CONSTANTS.LABELS.common_no}
                                    isChecked={(marketingProfilingInput === false)}
                                    onChange={(e) => {
                                      setMarketingProfilingInput(false);
                                      setMarketingInput(false);
                                      setProfilingInput(false);
                                    }}
                                    customLabelStyle={{ paddingLeft : 5 }}
                                    customInputStyle={{ position: "relative" }}
                                />
                            </div>

                            <div className="newConsentLineHeight" dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label2 }}></div>
                            <div className="newConsentLineHeight" dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label3 }}></div>
                            <div className="newConsentLineHeight" dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label4 }}></div>
                            <div className="newConsentMargin newConsentLineHeight">
                                {CONSTANTS.LABELS.userinfos_newconsent_expand1}{" "}
                                <span className="newConsentExpand" onClick={() => setIsNewConsentExpanded(!isNewConsentExpanded)}>
                                    {CONSTANTS.LABELS.userinfos_newconsent_expand2}
                                </span>
                                <img src={arrowExpand} width={isMobile() ? 17 : 18} className={`arrowExpand ${isNewConsentExpanded ? "expandUp" : "expandDown"}`} />
                            </div>

                            {
                                <React.Fragment>
                                    <div style={{ display: isNewConsentExpanded ? undefined : "none" }}>
                                        <div className="newConsentTitleRadioContainer">
                                            <div className="newConsentTitle">{CONSTANTS.LABELS.userinfos_newconsent_title3}</div>
                                            <Radio
                                                name="marketing"
                                                id="marketing-yes"
                                                label={CONSTANTS.LABELS.common_yes}
                                                isChecked={(marketingInput === true)}
                                                onChange={(e) => {
                                                    setMarketingInput(true);
                                                    if (profilingInput) {
                                                        setMarketingProfilingInput(true);
                                                    }
                                                }}
                                                customLabelStyle={{ paddingLeft : 5 }}
                                                customInputStyle={{ position: "relative" }}
                                            />
                                            <Radio
                                                name="marketing"
                                                id="marketing-no"
                                                label={CONSTANTS.LABELS.common_no}
                                                isChecked={(marketingInput === false)}
                                                onChange={(e) => {
                                                    setMarketingInput(false);
                                                    if (profilingInput === false) {
                                                        setMarketingProfilingInput(false);
                                                    }
                                                }}
                                                customLabelStyle={{ paddingLeft : 5 }}
                                                customInputStyle={{ position: "relative" }}
                                            />
                                        </div>

                                        <div className="newConsentMargin newConsentLineHeight" dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label5 }}></div>

                                        <div className="newConsentTitleRadioContainer">
                                            <div className="newConsentTitle">{CONSTANTS.LABELS.userinfos_newconsent_title4}</div>
                                            <Radio
                                                name="profiling"
                                                id="profiling-yes"
                                                label={CONSTANTS.LABELS.common_yes}
                                                isChecked={(profilingInput === true)}
                                                onChange={(e) => {
                                                    setProfilingInput(true);
                                                    if (marketingInput) {
                                                        setMarketingProfilingInput(true);
                                                    }
                                                }}
                                                customLabelStyle={{ paddingLeft : 5 }}
                                                customInputStyle={{ position: "relative" }}
                                            />
                                            <Radio
                                                name="profiling"
                                                id="profiling-no"
                                                label={CONSTANTS.LABELS.common_no}
                                                isChecked={(profilingInput === false)}
                                                onChange={(e) => {
                                                    setProfilingInput(false)
                                                    if (marketingInput === false) {
                                                        setMarketingProfilingInput(false);
                                                    }
                                                }}
                                                customLabelStyle={{ paddingLeft : 5 }}
                                                customInputStyle={{ position: "relative" }}
                                            />
                                        </div>

                                        <div className="newConsentMargin newConsentLineHeight" dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label6 }}></div>
                                    </div>

                                </React.Fragment>}


                            <div className="newConsentTitleRadioContainer">
                                <div className="newConsentTitle">{CONSTANTS.LABELS.userinfos_newconsent_title5}</div>
                                <Radio
                                    name="thirdParty"
                                    id="thirdParty-yes"
                                    label={CONSTANTS.LABELS.common_yes}
                                    isChecked={(thirdPartyInput === true)}
                                    onChange={(e) => setThirdPartyInput(true)}
                                    customLabelStyle={{ paddingLeft : 5 }}
                                    customInputStyle={{ position: "relative" }}
                                />
                                <Radio
                                    name="thirdParty"
                                    id="thirdParty-no"
                                    label={CONSTANTS.LABELS.common_no}
                                    isChecked={(thirdPartyInput === false)}
                                    onChange={(e) => setThirdPartyInput(false)}
                                    customLabelStyle={{ paddingLeft : 5 }}
                                    customInputStyle={{ position: "relative" }}
                                />
                            </div>

                            <div className="newConsentLineHeight" dangerouslySetInnerHTML={{ __html: CONSTANTS.LABELS.userinfos_newconsent_label7 }}></div>
                        </React.Fragment>
                    }

                    {isMentionLegalActivated && CONSTANTS.SITE_INFO.BRAND_CODE !== 'V' && <h6 tabIndex='0' className="legalNotice_headline">
                        {CONSTANTS.LABELS.userinfos_legal_notice_title}
                    </h6>}
                    {isMentionLegalActivated && <CheckBox wrapperClasses="legal-mention"
                        id="legal-mention"
                        label={CONSTANTS.LABELS.userinfos_legal_notice}
                        isChecked={isLegalMentionsChecked}
                        onClick={(e) => {
                            setIsLegalMentionsChecked(e.target.checked)
                        }} />
                    }
                </div>
            </div>
            <StickyButton
                label={CONSTANTS.LABELS.common_v2_continue}
                isDisabled={(isMentionLegalActivated && !isLegalMentionsChecked) || (isNewConsentActive && (marketingProfilingInput === '' || thirdPartyInput === ''))}
                handleClick={checkFormValidity}
            />
        </>
    );
}

export default YourPersonalInfoPage;